export default "<ion-label> {{ dateObj  }} </ion-label>\n\n<!-- <ion-label> {{ dateObj  | date:'d/M/yyyy' }} </ion-label> -->";